export const maxStrLength = (max: number) => (str: unknown) => {
  if (typeof str === 'string' && str.length > max) {
    return true;
  }

  return null;
};
